import React from "react";

export const ExpandIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="20" fill="white" />
      <path
        d="M16.8149 25.2897C16.4436 25.7317 16.3935 26.5199 16.7028 27.0502C17.0122 27.5805 17.5639 27.6522 17.9352 27.2102L23.1852 20.9603C23.6049 20.4605 23.6049 19.5395 23.1852 19.0397L17.9352 12.7898C17.5639 12.3478 17.0122 12.4195 16.7028 12.9498C16.3935 13.4801 16.4436 14.2683 16.8149 14.7103L21.2582 20L16.8149 25.2897Z"
        fill="#0073C8"
      />
    </svg>
  );
};

export const CollapseIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ outline: "none", border: "none" }}
    >
      <rect width="40" height="40" rx="20" fill="white" />
      <path
        d="M14.7103 16.8149C14.2683 16.4436 13.4801 16.3935 12.9498 16.7028C12.4195 17.0122 12.3478 17.5639 12.7898 17.9352L19.0397 23.1852C19.5395 23.6049 20.4605 23.6049 20.9603 23.1852L27.2102 17.9352C27.6522 17.5639 27.5805 17.0122 27.0502 16.7028C26.5199 16.3935 25.7317 16.4436 25.2897 16.8149L20 21.2582L14.7103 16.8149Z"
        fill="#0073C8"
      />
    </svg>
  );
};
